var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownBigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41073 6.91058C4.73617 6.58514 5.26381 6.58514 5.58925 6.91058L9.99999 11.3213L14.4107 6.91058C14.7362 6.58514 15.2638 6.58514 15.5892 6.91058C15.9147 7.23602 15.9147 7.76366 15.5892 8.08909L10.5892 13.0891C10.2638 13.4145 9.73617 13.4145 9.41073 13.0891L4.41073 8.08909C4.0853 7.76366 4.0853 7.23602 4.41073 6.91058Z",
    fill: "#323031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBigger);
export default __webpack_public_path__ + "static/media/chevron-down-bigger.38d2f860cd4b4d23ed43d289bbe7abda.svg";
export { ForwardRef as ReactComponent };